export enum NatImplementor {
  MIN_OF_ENV = 'Ministry of Environment and Climate Change',
  MIN_OF_STATE_ENERGY = 'Ministry of State for Energy Affairs',
  MIN_OF_FINANCE = 'Ministry of Finance',
  MIN_OF_MUNICIPALITY = 'Ministry of Municipality',
  MIN_OF_TRANSPORT = 'Ministry of Transport',
  MIN_OF_COMMERCE = 'Ministry of Commerce and Industry',
  MIN_OF_HEALTH = 'Ministry of Public Health',
  MIN_OF_EDUCATION = 'Ministry of Education and Higher Education',
  MIN_OF_FOREIGN = 'Ministry of Foreign Affairs',
  MIN_OF_INTERIOR = 'Ministry of Interior',
  MIN_OF_DEFENCE = 'Ministry of Defence Affairs',
  MIN_OF_LABOUR = 'Ministry of Labour',
  MIN_OF_COMMS_TECH = 'Ministry of Communications and Information Technology',
  MIN_OF_CABINET = 'Ministry of State for Cabinet Affairs',
  MIN_OF_SOCIAL_DEV = 'Ministry of Social Development and Family',
  MIN_OF_CULTURE = 'Ministry of Culture',
  MIN_OF_LABOUR_SOCIAL = 'Ministry of Labour and Social Affairs',
  MIN_OF_PLANNING_STATS = 'Ministry of Development Planning & Statistics',
  STATE_AUDIT_BUREAU = 'State Audit Bureau',
  QATAR_ENERGY = 'QatarEnergy',
  QATAR_ELEC_WATER = 'Qatar General Electricity & Water Corporation',
  PUBLIC_WORKS_AUTH = 'Public Works Authority (Ashghal)',
  QATAR_PORTS = 'Qatar Ports Management Company',
  QATAR_CAA = 'Qatar Civil Aviation Authority',
  MOWASALAT = 'Mowasalat (Karwa)',
  QATAR_MET_DEPT = 'Qatar Meteorology Department',
  QATAR_AIRWAYS = 'Qatar Airways',
  QATAR_INVEST_AUTH = 'Qatar Investment Authority',
  QATAR_DEV_FUND = 'Qatar Fund for Development',
  QEERI = 'Qatar Environment & Energy Research Institute',
}

export enum IntImplementor {
  AFC = 'AFC',
  AFD = 'AFD',
  AFDB = 'AFDB',
  EBRD = 'EBRD',
  EIB = 'EIB',
  FAO = 'FAO',
  GCF = 'GCF',
  GEF = 'GEF',
  GIZ = 'GIZ',
  IMF = 'IMF',
  IMO = 'IMO',
  IUCN = 'IUCN',
  NEFCO = 'NEFCO',
  UNWO = 'UN Women',
  UNDP = 'UNDP',
  UNEP = 'UNEP',
  UNESCO = 'UNESCO',
  UNFCCC = 'UNFCCC',
  UNFPA = 'UNFPA',
  UNICEF = 'UNICEF',
  UNIDO = 'UNIDO',
  USAID = 'USAID',
  WFP = 'WFP',
  WMO = 'WMO',
  WB = 'World Bank',
}

export enum Recipient {
  MIN_OF_ENV = 'Ministry of Environment and Climate Change',
  MIN_OF_STATE_ENERGY = 'Ministry of State for Energy Affairs',
  MIN_OF_FINANCE = 'Ministry of Finance',
  MIN_OF_MUNICIPALITY = 'Ministry of Municipality',
  MIN_OF_TRANSPORT = 'Ministry of Transport',
  MIN_OF_COMMERCE = 'Ministry of Commerce and Industry',
  MIN_OF_HEALTH = 'Ministry of Public Health',
  MIN_OF_EDUCATION = 'Ministry of Education and Higher Education',
  MIN_OF_FOREIGN = 'Ministry of Foreign Affairs',
  MIN_OF_INTERIOR = 'Ministry of Interior',
  MIN_OF_DEFENCE = 'Ministry of Defence Affairs',
  MIN_OF_LABOUR = 'Ministry of Labour',
  MIN_OF_COMMS_TECH = 'Ministry of Communications and Information Technology',
  MIN_OF_CABINET = 'Ministry of State for Cabinet Affairs',
  MIN_OF_SOCIAL_DEV = 'Ministry of Social Development and Family',
  MIN_OF_CULTURE = 'Ministry of Culture',
  MIN_OF_LABOUR_SOCIAL = 'Ministry of Labour and Social Affairs',
  MIN_OF_PLANNING_STATS = 'Ministry of Development Planning & Statistics',
  STATE_AUDIT_BUREAU = 'State Audit Bureau',
  QATAR_ENERGY = 'QatarEnergy',
  QATAR_ELEC_WATER = 'Qatar General Electricity & Water Corporation',
  PUBLIC_WORKS_AUTH = 'Public Works Authority (Ashghal)',
  QATAR_PORTS = 'Qatar Ports Management Company',
  QATAR_CAA = 'Qatar Civil Aviation Authority',
  MOWASALAT = 'Mowasalat (Karwa)',
  QATAR_MET_DEPT = 'Qatar Meteorology Department',
  QATAR_AIRWAYS = 'Qatar Airways',
  QATAR_INVEST_AUTH = 'Qatar Investment Authority',
  QATAR_DEV_FUND = 'Qatar Fund for Development',
  QEERI = 'Qatar Environment & Energy Research Institute',
}

export enum EntityType {
  ACTION = 'action',
  PROGRAMME = 'programme',
  PROJECT = 'project',
  ACTIVITY = 'activity',
}

export enum GHGS {
  CO = 'CO2',
  COE = 'CO2e',
  CH = 'CH4',
  NO = 'N2O',
  HFC = 'HFCs',
  NF = 'NF3',
  PFC = 'PFCs',
  SF = 'SF6',
}

export enum SubSector {
  GRID_GENERAT = 'Grid-Connected Generation (electricity)',
  OFF_GRID_GENERAT = 'Off-Grid / Rural Generation (electricity)',
  TRANS_DISTR = 'Transmission & Distribution (electricity)',
  FUEL = 'Fuels',
  GOV = 'Government',
  INDUSTRY = 'Industry',
  APPLIANCES = 'Appliances',
  WATER = 'Water',
  CITIES = 'Cities',
  BUILDINGS = 'Buildings',
  LAND_TRANSPORT = 'Land (transport)',
  MARITIME_TRANSPORT = 'Maritime (transport)',
  AVIATION_TRANSPORT = 'Aviation (transport)',
  WASTE_WATER = 'Wastewater',
  WASTE_SOLID = 'Solid Waste',
  FORESTRY = 'Forestry',
  AGR_FORESTRY = 'Agroforestry',
  AGRICULTURE = 'Agriculture',
  LAND_USE = 'Land Use',
  COASTAL = 'Coastal',
  FISHING = 'Fishing',
  BIO_DIVERSITY = 'Biodiversity',
  ECO_SYS = 'Ecosystems',
  NATURE_BASED = 'Nature Based Solutions',
  TOURISM = 'Tourism',
  COMMERCIAL = 'Commercial',
  HOUSE_HOLDS = 'Households',
  FOOD_SYSTEMS = 'Food systems',
  MULTI_SUB_SEC = 'Multi-Subsector',
  NA = 'Not Applicable',
}

export enum TypeOfMitigation {
  AGRICULTURE = 'Agriculture',
  SOLAR = 'Solar',
  EE_HOUSEHOLDS = 'EEHouseholds',
}

export enum ExportFileType {
  XLSX = 'xlsx',
  CSV = 'csv',
}

export enum KPIAction {
  NONE = 'None',
  CREATED = 'Created',
  UPDATED = 'Updated',
}

export enum GHGRecordState {
  SAVED = 'SAVED',
  FINALIZED = 'FINALIZED',
}
